var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "transition",
    { attrs: { name: _vm.transition ? _vm.transitionName : "" } },
    [
      _c("div", { class: _vm.computedSizeClass, attrs: { id: _vm.hashId } }, [
        _vm.sideLabel
          ? _c(
              "div",
              { staticClass: "row align-items-center flex-sm-nowrap" },
              [
                _c("div", { class: "" + (_vm.sideLabelSize || "col-5") }, [
                  _c(
                    "h6",
                    {
                      class: _vm.getTitleClass(),
                      on: { click: _vm.handleClick },
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            _vm._f("getSchemaTranslation")(
                              _vm.title,
                              _vm.translationMap
                            )
                          ) +
                          "\n          "
                      ),
                      _vm.isValidationRequired
                        ? _c("input-required-indicator")
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.removable
                        ? _c(
                            "span",
                            [
                              _c("inline-prompt", {
                                ref: "prompt",
                                staticClass:
                                  "d-inline-block bold text-gray ml-2",
                                attrs: {
                                  "action-type": "delete",
                                  "confirmation-text": _vm.$t(
                                    "application.messages.allDataWillBeLost"
                                  ),
                                },
                                on: {
                                  accept: function ($event) {
                                    return _vm.remove()
                                  },
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "span",
                        { class: { "edit-visibility": _vm.editVisibility } },
                        [
                          _vm.editVisibility &&
                          !_vm.hideEye &&
                          _vm.dependsUponVisible
                            ? _c(
                                "a",
                                {
                                  ref: "eye",
                                  staticClass:
                                    "linked-section vis-mark clickable",
                                  attrs: {
                                    "data-toggle": "tooltip",
                                    "data-html": "true",
                                    "data-placement": "right",
                                    "data-original-title": _vm.eyeTooltipTitle,
                                  },
                                  on: { click: _vm.toggleVisibility },
                                },
                                [
                                  _c("i", {
                                    staticClass: "fa eye",
                                    class: _vm.isVisible
                                      ? "fa-eye"
                                      : "fa-eye-slash",
                                    attrs: { "aria-hidden": "true" },
                                  }),
                                ]
                              )
                            : _vm._e(),
                        ]
                      ),
                      _vm._v(" "),
                      _vm.iconTooltip && !_vm.editVisibility
                        ? _c("span", [
                            _c("i", {
                              ref: "informationTooltip",
                              class: "fa " + _vm.icon + " text-grey ml-1",
                              attrs: {
                                "aria-hidden": "true",
                                "data-toggle": "tooltip",
                                "data-placement": "top",
                                "data-original-title": _vm.iconTooltip,
                              },
                            }),
                          ])
                        : _vm._e(),
                    ],
                    1
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    class:
                      _vm.containerClass +
                      " position-relative client-application-form-container " +
                      (_vm.editVisibility ? "edit-visibility" : ""),
                  },
                  [
                    _vm._t("default"),
                    _vm._v(" "),
                    _vm.editVisibility &&
                    !_vm.hideEye &&
                    !_vm.hideRequiredIndicator
                      ? _c(
                          "a",
                          {
                            ref: "mandatory",
                            staticClass:
                              "btn btn-white linked-section btn-sm required-mark clickable",
                            class: { "bg-danger": _vm.isRequired },
                            attrs: {
                              "data-key": "",
                              "data-section": "",
                              "data-required": "true",
                              "data-toggle": "tooltip",
                              "data-html": "true",
                              "data-placement": "right",
                              "data-original-title": _vm.mandatoryTooltipTitle,
                            },
                            on: { click: _vm.toggleValidation },
                          },
                          [
                            _c("i", {
                              staticClass: "fa fa-asterisk required-asterisk",
                              class: _vm.isRequired
                                ? "text-white"
                                : "text-gray",
                              attrs: { "aria-hidden": "true" },
                            }),
                          ]
                        )
                      : _vm._e(),
                  ],
                  2
                ),
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.sideLabel
          ? _c("div", {
              class: {
                overlay: _vm.editVisibility || _vm.overlay,
                clear: !_vm.isVisible,
              },
            })
          : _vm._e(),
        _vm._v(" "),
        !_vm.sideLabel && _vm.title
          ? _c(
              "h6",
              { class: _vm.getTitleClass(), on: { click: _vm.handleClick } },
              [
                _vm._v(
                  "\n      " +
                    _vm._s(
                      _vm._f("getSchemaTranslation")(
                        _vm.title,
                        _vm.translationMap
                      )
                    ) +
                    "\n      "
                ),
                _vm.isValidationRequired
                  ? _c("input-required-indicator")
                  : _vm._e(),
                _vm._v(" "),
                _vm.removable
                  ? _c(
                      "span",
                      [
                        _c("inline-prompt", {
                          ref: "prompt",
                          staticClass: "d-inline-block bold text-gray ml-2",
                          attrs: {
                            "action-type": "delete",
                            "confirmation-text": _vm.$t(
                              "application.messages.allDataWillBeLost"
                            ),
                          },
                          on: {
                            accept: function ($event) {
                              return _vm.remove()
                            },
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c("span", { staticClass: "edit-visibility" }, [
                  _vm.editVisibility && !_vm.hideEye && _vm.dependsUponVisible
                    ? _c(
                        "a",
                        {
                          ref: "eye",
                          staticClass: "linked-section vis-mark clickable",
                          attrs: {
                            "data-toggle": "tooltip",
                            "data-html": "true",
                            "data-placement": "right",
                            "data-original-title": _vm.eyeTooltipTitle,
                          },
                          on: { click: _vm.toggleVisibility },
                        },
                        [
                          _c("i", {
                            staticClass: "fa eye",
                            class: _vm.isVisible ? "fa-eye" : "fa-eye-slash",
                            attrs: { "aria-hidden": "true" },
                          }),
                        ]
                      )
                    : _vm._e(),
                ]),
                _vm._v(" "),
                _vm.iconTooltip && !_vm.editVisibility
                  ? _c("span", [
                      _c("i", {
                        ref: "informationTooltip",
                        class: "fa " + _vm.icon + " text-grey ml-1",
                        attrs: {
                          "aria-hidden": "true",
                          "data-toggle": "tooltip",
                          "data-placement": "top",
                          "data-original-title": _vm.iconTooltip,
                        },
                      }),
                    ])
                  : _vm._e(),
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        !_vm.sideLabel
          ? _c(
              "div",
              {
                class:
                  _vm.containerClass +
                  " position-relative client-application-form-container " +
                  (_vm.editVisibility ? "edit-visibility" : ""),
              },
              [
                _vm._t("default"),
                _vm._v(" "),
                _vm.editVisibility && !_vm.hideEye
                  ? _c(
                      "a",
                      {
                        ref: "mandatory",
                        staticClass:
                          "btn btn-white linked-section btn-sm required-mark clickable",
                        class: { "bg-danger": _vm.isRequired },
                        attrs: {
                          "data-key": "",
                          "data-section": "",
                          "data-required": "true",
                          "data-toggle": "tooltip",
                          "data-html": "true",
                          "data-placement": "right",
                          "data-original-title": _vm.mandatoryTooltipTitle,
                        },
                        on: { click: _vm.toggleValidation },
                      },
                      [
                        _c("i", {
                          staticClass: "fa fa-asterisk required-asterisk",
                          class: _vm.isRequired ? "text-white" : "text-gray",
                          attrs: { "aria-hidden": "true" },
                        }),
                      ]
                    )
                  : _vm._e(),
              ],
              2
            )
          : _vm._e(),
        _vm._v(" "),
        !_vm.sideLabel
          ? _c("div", {
              class: {
                overlay: _vm.editVisibility || _vm.overlay,
                clear: !_vm.isVisible,
              },
            })
          : _vm._e(),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }